import React from "react";
import PropTypes from "prop-types";

import globalStyles from "../../globalStyles";
import useWindowSize from "../../hooks/useWindowSize";
import { K_MOBILE_SIZE } from "../../constants";

const Section = (props) => {
  const { style, anchorRef, children } = props;

  const { width } = useWindowSize();
  const styles = {
    ...pcStyles,
    ...(width < K_MOBILE_SIZE ? mobileStyles : {}),
  };

  return (
    <div style={{ ...styles.section, ...(style || {}) }} ref={anchorRef}>
      <div>{children}</div>
    </div>
  );
};

const pcStyles = {
  section: {
    ...globalStyles.section,
  },
};

const mobileStyles = {
  section: {
    ...globalStyles.mobileSection,
  },
};

Section.propTypes = {
  style: PropTypes.shape().isRequired,
  anchorRef: PropTypes.shape(),
  children: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.arrayOf(PropTypes.element)
  ])
};

export default Section;
